export const PRICING = {
  // Individual Product Pricing
  MONTHLY: "6.99",
  YEARLY: "29.99",
  LIFETIME: "49.99",

  // Bundle Pricing
  BUNDLE_LIFETIME: "149.99",

  // Calculated/Display Values
  // NOTE: bundle full value / savings live in lib/product-stats.ts — they are
  // derived from the product registry so they can never drift from the count.
  YEARLY_SAVINGS_PERCENT: "64",
} as const;

/**
 * The All-Access Bundle's Lemon Squeezy checkout. One place: every product's bundle offer and
 * every bundle Buy button read it. It was also overridable by NEXT_PUBLIC_LEMONSQUEEZY_CHECKOUT_URL,
 * but only the Buy buttons honoured that (the product offers hardcoded the URL), so an override
 * would have split the site between two checkouts. Per-product checkout URLs live in each
 * product's `offers`.
 */
export const BUNDLE_CHECKOUT_URL =
  "https://products.plugmonkey.xyz/checkout/buy/9a15e7b6-90c3-4ae3-9804-04c0057da636";
